import { useState } from "react";
import { ArrowLeft, KeyRound } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import MacJitLogo from "../components/MacJitLogo";
import { useAuth } from "../context/AuthContext";

export default function ResetPasswordPage() {
  const { confirmPasswordReset } = useAuth();
  const [searchParams] = useSearchParams();
  const nav = useNavigate();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) return toast.error("Reset token missing");
    if (password !== confirm) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      await confirmPasswordReset(token, password);
      toast.success("Password updated. Please sign in.");
      nav("/terminal");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not reset password");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white grid-bg">
      <main className="mx-auto grid min-h-screen max-w-xl place-items-center px-6 py-12">
        <form onSubmit={submit} className="w-full border border-zinc-800 bg-zinc-950 p-6 shadow-2xl shadow-orange-500/10 sm:p-8">
          <button type="button" onClick={() => nav("/terminal")} className="mb-8 inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-widest text-zinc-500 hover:text-orange-500">
            <ArrowLeft className="h-3 w-3" /> Terminal
          </button>
          <div className="flex items-center gap-3">
            <MacJitLogo size={38} />
            <div>
              <p className="font-display text-xl font-black tracking-tighter">MACJIT <span className="text-orange-500">/ RESET</span></p>
              <p className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">Terminal account recovery</p>
            </div>
          </div>
          <div className="mt-10">
            <KeyRound className="h-10 w-10 text-orange-500" />
            <h1 className="mt-4 font-display text-4xl font-black uppercase tracking-tighter">Set new password</h1>
            <p className="mt-3 text-sm leading-relaxed text-zinc-400">Use a strong password. After this, temporary passwords and old reset links stop working.</p>
          </div>
          <div className="mt-8 space-y-4">
            <input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password" className="w-full border border-zinc-800 bg-black px-4 py-3 font-mono text-white outline-none focus:border-orange-500" />
            <input type="password" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirm new password" className="w-full border border-zinc-800 bg-black px-4 py-3 font-mono text-white outline-none focus:border-orange-500" />
          </div>
          <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.16em] text-zinc-500">Must include uppercase, lowercase and a number.</p>
          <button disabled={busy || !token} className="mt-8 w-full bg-orange-500 py-4 font-display font-black uppercase tracking-widest text-black hover:bg-orange-400 disabled:opacity-50">
            {busy ? "Updating..." : "Update password"}
          </button>
        </form>
      </main>
    </div>
  );
}
